import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ABCOrdbogenIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      height={getDefaultHeight(svgProps, 30)}
      {...svgProps}
      fill="none"
      stroke={color ?? "currentColor"}
      strokeWidth="1.5"
    >
      <rect height="18" rx="1" width="4" x="11" y="6" />
      <rect
        height="18.1169"
        rx="1"
        transform="matrix(.96592583 -.25881905 .25881905 .96592583 -1.241603 4.639645)"
        width="4"
        x="17"
        y="7.03528"
      />
      <rect height="9" rx="1" width="4" x="5" y="15" />
    </SVG>
  );
};
